// extracted by mini-css-extract-plugin
export default {"page":"SY-z","cartModal":"TY-z","checkout":"UY-z","placeholder":"VY-z","account":"WY-z"};